/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetTransportsColorsIdQueryResponse, GetTransportsColorsIdPathParams, GetTransportsColorsId400 } from '../entities/GetTransportsColorsId'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getGetTransportsColorsIdUrl(id: GetTransportsColorsIdPathParams['id']) {
  return `/transports/colors/${id}` as const
}

/**
 * @description Get all transport colors
 * @summary Get all transport colors
 * {@link /transports/colors/:id}
 */
export async function getTransportsColorsId(id: GetTransportsColorsIdPathParams['id'], config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<GetTransportsColorsIdQueryResponse, ResponseErrorConfig<GetTransportsColorsId400>, unknown>({
    method: 'GET',
    url: getGetTransportsColorsIdUrl(id).toString(),
    ...requestConfig,
  })
  return res.data
}